export class RouteConstants {
  static readonly root = '/';
  static readonly home = '/home';
  static readonly styleGuide = '/style-guide';
  static readonly logout = '/logout';
}
